import React, { useMemo, useState, useEffect } from "react"
import { useSelector } from 'react-redux'
import { getGlobalProps } from 'state-management/selectors'
import { useViewport } from 'components/general/useViewPort'
import Moment from 'react-moment';
import MirsTable from "components/general/table/Table"
import { Accordion } from 'react-bootstrap'
import { ColumnTime, ColumnStatus, ColumnEvent, ColumnEventWithCompetitor, ColumnCompetitor, ColumnResult, ColumnLocation } from "components/common/schedule/TableColumns"
import { useUrlFriendlyToParameters, useNavigateTo } from 'helpers/urlFriendly';
import { getLevelRSC, getLongEventRSC } from "helpers/rsc"
import Discipline from "components/presentation/Discipline";
import { ALL_URL } from "helpers/utils";
import { useQueryClient } from "react-query";

const getConfiguration = (breakPoint, globalProps, eventorder, dataSportCodes) => {
  const isMobile = (breakPoint === "sm" || breakPoint === "xs")

  let configuration = {
    columns: [],
    sortBy: [],
    disableSort: false
  };

  configuration.sortBy = []

  switch (eventorder) {
    case 'DATE':
      configuration.sortBy = [{ id: 'Time', desc: false }]
      break;
    case 'LOC':
      configuration.sortBy = [{ id: 'Location', desc: false }]
      configuration.disableSort = true
      break;
  }

  configuration.columns = isMobile ? TableColumnsSM(globalProps, dataSportCodes) : TableColumns(globalProps, configuration.disableSort, dataSportCodes)

  return configuration;
};




const DateScheduleTable = ({ data, eventorder }) => {
  const { breakPoint } = useViewport();
  const globalProps = useSelector(getGlobalProps)
  const day = data[0]?.startDate
  const discipline = data[0]?.discipline?.code
  const [dataSportCodes, setDataSportCodes] = useState()
  const queryClient = useQueryClient();
  const { mirs_competition, mirs_language } = useUrlFriendlyToParameters()
  useEffect(() => {
      setDataSportCodes(queryClient.getQueryData(["SportCodes", mirs_competition, mirs_language])?.sportCodes);
  }, [])

  const config = useMemo(() => getConfiguration(breakPoint, globalProps, eventorder, dataSportCodes), [breakPoint, globalProps.timezone, dataSportCodes]);

  const [paramsUrl, setParamsUrl] = useState({});
  const [shouldNavigate, setShouldNavigate] = useState(false);
  useNavigateTo(paramsUrl, shouldNavigate, setShouldNavigate, paramsUrl['type'])//useGetURL(paramsURL, 'results')

  //Prepare URL to navigate
  const params = useUrlFriendlyToParameters()
  let paramsURL = { ...params }
  const showDiscipline = paramsURL["mirs_discipline"] === ALL_URL.ALL_DISC

  const handleClick = (props) => {
    const rsc = props?.eventUnit?.code;
    paramsURL['type']= 'results' 
    if (/FEN.................--GP..--------/.test(rsc)){
      paramsURL["mirs_event_rsc"] = getLongEventRSC(rsc)
      paramsURL["mirs_rsc"] = getLongEventRSC(rsc)
      paramsURL['type']= 'pool' 
    } else if (getLevelRSC(paramsURL["mirs_rsc"]) === "EVENT") {
      paramsURL["mirs_event_rsc"] = rsc
      paramsURL["mirs_rsc"] = undefined
    } else {
      //Phase or unit
      paramsURL["mirs_event_rsc"] = getLongEventRSC(rsc)
      paramsURL["mirs_rsc"] = rsc
    }
    setParamsUrl(paramsURL);
    if (rsc.indexOf('TMRY') === -1) {
      setShouldNavigate(true);
    }
  };

  return (
    <Accordion className='schedule-container' defaultActiveKey="0">
      <Accordion.Item eventKey="0">
        <Accordion.Header className='schedule-title'>

          {showDiscipline
            ? <Discipline code={data[0]?.discipline?.code} className={'img-fluid page-header-disciplina float-start w-5'} />
            : <Moment tz={globalProps.timezone} format="dddd Do MMMM">
              {day}
            </Moment>}
        </Accordion.Header>
        <Accordion.Body className="p-0">

          <MirsTable
            className="table-schedule"
            data={data}
            columns={config.columns}
            keyRow='eventUnit-code'
            initialSortBy={config.sortBy}
            rowOnClick={true}
            rowClickHandler={handleClick}
            id={`mirs-table-schedule-${discipline}-${day}`}
            getRowProps={row => (
              {
                className: (row.original?.code?.indexOf('TMRY') === -1) ? 'clickable-row' : ''
              }
            )}
          />
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
  )
}

export default DateScheduleTable;



function TableColumns(globalProps, disableSort, dataSportCodes) {
  return (
    [
      ColumnTime(globalProps, { disableSort: disableSort, dataSportCodes: dataSportCodes }),
      ColumnEvent({ disableSort: disableSort }),
      ColumnCompetitor({}),
      ColumnResult({}),
      ColumnStatus({}),
      ColumnLocation({ disableSort: disableSort })
    ]
  )
}

function TableColumnsSM(globalProps, dataSportCodes) {
  return (
    [
      ColumnTime(globalProps, { disableSort: true, dataSportCodes: dataSportCodes }),
      ColumnEventWithCompetitor({ disableSort: true })
    ]
  )
}


